import { render, staticRenderFns } from "./ContactMe.vue?vue&type=template&id=fb56f74c&scoped=true&"
import script from "./ContactMe.vue?vue&type=script&lang=js&"
export * from "./ContactMe.vue?vue&type=script&lang=js&"
import style0 from "./ContactMe.vue?vue&type=style&index=0&id=fb56f74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb56f74c",
  null
  
)

export default component.exports